<template>
  <!-- There should only be 3 types of colors: red, green & yellow -->
  <div class="stat-card rb white-txt" :class="color">
    <div class="stat">
      <growing-number :value="statNumber" />
    </div>
    <div class="stat-one">
      <div class="component-header">{{ statTitle }}</div>
    </div>
  </div>
</template>

<script>
import GrowingNumber from "@/modules/global/components/GrowingNumber.vue";
export default {
  name: "statCard",
  props: {
    statTitle: {
      type: String,
      require: true
    },
    statNumber: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: "green"
    }
  },
  components: {
    GrowingNumber
  }
};
</script>
